import {Stack, Typography} from '@mui/material';
import React from 'react';

import {Row, StyledCard} from 'presentation/components';
import {useGetBeneficiaryBankDataQuery} from 'presentation/pages/private/profile/queries/useGetBeneficiaryBankDataQuery';
import {translations} from 'presentation/translations-new';
import {SkeletonData} from 'presentation/components/ChangeData/SkeletonData';

const {title, bank, agencyNotDigit, account, digit} =
	translations['pt-br'].privateFlow.refund.conferencePage.bankInfo;

export const BankInfoCardTherapies = () => {
	const {data: bankData, isLoading} = useGetBeneficiaryBankDataQuery();

	if (isLoading) {
		return (
			<Stack gap={2} p={2}>
				<SkeletonData type="bank" />
			</Stack>
		);
	}

	const bankDescription = `${bankData?.bank.code} - ${bankData?.bank.description || '-'}`;

	return (
		<StyledCard.Container>
			<Typography fontWeight={600} variant="subtitle2" color={'text.secondary'}>
				{title}
			</Typography>

			<Row.Simple title={bank} value={bankDescription} />

			<Row.Compound
				items={[
					{
						title: agencyNotDigit,
						value: bankData!.agency,
					},
				]}
			/>

			<Row.Compound
				hiddenDivider
				items={[
					{
						title: account,
						value: bankData!.account,
					},
					{
						title: digit,
						value: bankData?.accountDigit || '-',
					},
				]}
			/>
		</StyledCard.Container>
	);
};
